//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import btn from '../../../../components/btn';
import x24icloader from '../../../../iconsPublicSite/icons/x24icloader/x24icloader';

export default {
  components: {
    x24icloader,
  },
  extends: btn,
  props: {
    rect: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },

    // Для кнопок с бордером можно указать его ширину
    // Указывается просто число, без px
    borderWidth: {
      type: [Number, String],
      default: 2,
    },
    // Некоторые кнопки поддерживают отражение своего фона при ховере
    reverse: {
      type: Boolean,
      default: false,
    },
    // Кнопка, выглядящая как текст (без паддингов и обводок)
    text: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: 'primary',
      validator: (value) => {
        return [
          'primary',
          'secondary',
          'tetriary',
          'quaternary',
          'white',
          'old',
          'old-secondary',
          'dark',
          'depressed',
        ].indexOf(value) !== -1;
      },
    },
  },
  watch: {
    // По-умолчанию ширина бордера 2px
    borderWidth: {
      handler(payload) {
        let width = 2;

        if (payload) width = payload;
        this.styles['--border-width'] = `${width}px`;
      },
      immediate: true,
    },
  },
  mounted() {
    this.setHoverColor();
  },
  methods: {
    // onHover и onLeave переопределяются на пустые функции, так как базовое поведение
    // из ui-kit кнопки не нужно для версии кнопок на публичном сайте.
    // Здесь кастомный ховер устанавливается через css-переменную в mounted
    onHover(event) {},
    onLeave(event) {},
    setHoverColor() {
      if (!this.hoverColor) return;

      const el = this.$el;
      el?.style?.setProperty('--hoverBackground', this.hoverColor);
    },
  },
};
